export var NetboxStatus;
(function (NetboxStatus) {
    NetboxStatus[NetboxStatus["Disabled"] = 0] = "Disabled";
    NetboxStatus[NetboxStatus["Idle"] = 1] = "Idle";
    NetboxStatus[NetboxStatus["Active"] = 2] = "Active";
})(NetboxStatus || (NetboxStatus = {}));
